"use client";

import { useEffect, useRef } from "react";
import { sendGTMEvent } from "@next/third-parties/google";

export default function SubscriptionConversionTracker({
    subscriptionStarted,
    subscriptionPrice,
    userId,
}) {
    const conversionSent = useRef(false);

    useEffect(() => {
        if (subscriptionStarted && subscriptionPrice && !conversionSent.current) {
            // GTM Event - premium_subscription
            sendGTMEvent({
                event: "premium_subscription",
                subscriptionValue: subscriptionPrice,
            });

            conversionSent.current = true;

            // Nettoyer l'URL pour que la modale de bienvenue ne réapparaisse
            // pas à chaque rechargement (UserLayout a déjà capturé le
            // paramètre au premier rendu pour le rafraîchissement de session).
            const url = new URL(window.location.href);
            url.searchParams.delete("subscription_started");
            url.searchParams.delete("subscription_type");
            url.searchParams.delete("subscription_price");
            window.history.replaceState({}, "", url.toString());
        }
    }, [subscriptionStarted, subscriptionPrice, userId]);

    return null;
}
